// extracted by mini-css-extract-plugin
export default {"wrapper":"Login_wrapper__+wd9j","form":"Login_form__xawx9","title":"Login_title__vcg8P","amprimary":"Login_amprimary__GSuVm"};